import { render, staticRenderFns } from "./HJ0053.vue?vue&type=template&id=5dd23ad2&scoped=true&"
import script from "./HJ0053.vue?vue&type=script&lang=js&"
export * from "./HJ0053.vue?vue&type=script&lang=js&"
import style0 from "./HJ0053.vue?vue&type=style&index=0&id=5dd23ad2&prod&lang=less&scoped=true&"
import style1 from "./HJ0053.vue?vue&type=style&index=1&id=5dd23ad2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dd23ad2",
  null
  
)

export default component.exports